module.exports = __webpack_public_path__ + "media/metronic/_theme/media/project-logos/7-b775d138492671a2c01f4e75ccaadcbd.png";